import { render, staticRenderFns } from "./bank-account-list.vue?vue&type=template&id=6a529300"
import script from "./bank-account-list.vue?vue&type=script&lang=js"
export * from "./bank-account-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports